import { colors, HStack, responsive, VLine, VStack } from "goi_common";
import { DetailsSection } from "./components/DetailSection";
import ServiceInfoSection from "./components/ServiceInfoSection";
import CommonPackageExtraDetails from "./components/CommonPackageExtraDetails";
import InfoSection from "./components/InfoSection";
import { Box, Flex, Stack } from "@chakra-ui/react";
import ProductPaymentProcessImage from "../registration/components/ProductPriceContainer/ProductPaymentProcessImage";
import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";
import { 무빈소장2026 } from "goi_common/src/constants/servicePackages/service2026/무빈소장";
import { 일반장2026 } from "goi_common/src/constants/servicePackages/service2026/일반장";
import { useState } from "react";

import styled from "@emotion/styled";
import LandingFixedButton from "@/components/common/LandingFixedButton";
import { useFunnelData } from "@/utils/getFunnelRouteDetail";

const services = ["무빈소장" as const, "가족장" as const, "일반장" as const];
const items = [
  "가격" as const,
  "접객도우미" as const,
  "장례 용품" as const,
  "장의 차량" as const,
];
const servicePackagesDetail = {
  무빈소장: 무빈소장2026,
  가족장: 가족장2026,
  일반장: 일반장2026,
};
const suffix: Partial<Record<typeof items[number], string>> = {
  가격: "만 원",
  "장의 차량": "대",
};

export default function ServiceContainer({
  isTossProcess,
  href,
}: {
  isTossProcess?: boolean;
  href?: string;
}) {
  const [type, setType] = useState<typeof services[number]>("가족장");

  const { funnelRoutePaths } = useFunnelData();

  return (
    <VStack width="100%" alignItems="center">
      <VStack maxWidth="500px" width="100%" padding="0 0 76px">
        {/* <TitleSection /> */}

        <Box
          className="gray600 body_16_r"
          css={{
            padding: "16px 24px 0px",
          }}
        >
          <Box className="gray900 head_24_eb">서비스 안내</Box>
          <Box margin="20px 0">
            <b>
              장례 발생 전 선택한 월 납입금을 먼저 납부하고, 상품 차액은 장례 후
              납부
            </b>
            하는 상품입니다. <br />
            <br />
            <b>
              <u>장례 발생시 상품을 선택하시며,</u> 가족장({가족장2026.가격}
              만원)
            </b>{" "}
            외에도{" "}
            <b>
              무빈소장({무빈소장2026.가격}만원), 일반장({일반장2026.가격}
              만원)으로{" "}
            </b>
            이용하실 수 있습니다.
          </Box>

          <ProductPaymentProcessImage />
          <VLine
            width="100%"
            height="1px"
            color={colors.gray300}
            margin="12px 0"
          />
        </Box>
        <VStack>
          <HStack
            css={responsive({
              position: "sticky",
              top: { base: isTossProcess ? "70px" : "100px", lg: "70px" },
              background: "white",
              margin: { base: "20px 0", lg: "20px 0px" },
              padding: { base: "10px 12px 10px", lg: "20px 0px" },
              borderBottom: `1px solid ${colors.gray200}`,
              width: "100%",
            })}
          >
            {services.map((name) => (
              <Box
                key={name}
                className="gray900 subtitle_18_b"
                width="33.33%"
                textAlign="center"
                color={name === type ? colors.gray900 : colors.gray400}
                onClick={() => {
                  setType(name);
                  window.scrollTo({
                    top: document.getElementById("service_list_top")?.offsetTop,
                    behavior: "smooth",
                  });
                }}
                css={responsive({
                  cursor: "pointer",
                })}
              >
                {name}
              </Box>
            ))}
          </HStack>

          <VStack
            width="100%"
            gap={16}
            css={{
              textAlign: "center",
              padding: "0px 24px",
              marginTop: "30px",
            }}
          >
            <div className="head2_m gray900">
              고이 {type}
              <br />
              <b>다른 서비스와 비교하기</b>
            </div>
          </VStack>

          <NoScrollBarStack
            padding="16px 0 48px"
            gap={10}
            overflow="scroll"
            maxWidth="500px"
            width="100vw"
            alignItems="center"
            css={{
              justifyContent: "flex-start",
              ["@media (min-width: 450px)"]: {
                justifyContent: "center",
              },
            }}
          >
            <NoScrollBarStack
              maxWidth="390px"
              width="100%"
              padding="0px 24px"
              gap="20px"
              overflow="scroll"
              className=""
              alignItems="flex-end"
            >
              {services.map((name) => (
                <VStack gap={16} key={name} alignItems="center">
                  <Flex
                    className="subtitle2_sb"
                    id={name}
                    css={{
                      minHeight: "55px",
                      color: name === type ? colors.brown650 : colors.gray900,
                      alignItems: "center",
                    }}
                  >
                    {name}
                  </Flex>
                  <VStack
                    padding="24px 13px"
                    borderRadius={20}
                    gap={30}
                    background={name === type ? colors.gray900 : colors.gray50}
                    flexGrow={1}
                    width="100px"
                  >
                    {items.map((a) => (
                      <VStack key={a} alignItems="center">
                        <div
                          className="body2"
                          css={{
                            color:
                              name === type ? colors.brown50 : colors.gray600,
                          }}
                        >
                          {a}
                        </div>
                        <div
                          className="button"
                          css={{
                            color:
                              name === type ? colors.white : colors.gray800,
                          }}
                        >
                          {servicePackagesDetail[name][a]}
                          {suffix[a]}
                        </div>
                      </VStack>
                    ))}
                  </VStack>
                </VStack>
              ))}
            </NoScrollBarStack>
          </NoScrollBarStack>
        </VStack>

        <DetailsSection />
        <ServiceInfoSection
          details={servicePackagesDetail[type].details}
          type={type}
        />
        <CommonPackageExtraDetails type={type} />
        <InfoSection
          infoDescriptionItems={[
            ...servicePackagesDetail[type].deductions,
            ...servicePackagesDetail[type].extra,
          ]}
        />
      </VStack>
      <LandingFixedButton
        color={isTossProcess ? colors.orange650 : colors.gray900}
        text="고이와 함께 장례 준비 시작하기"
        href={
          isTossProcess
            ? "/toss/#benefit"
            : href || funnelRoutePaths?.["product-intro"] || "/"
        }
        eventPath="feed"
      />
    </VStack>
  );
}

const NoScrollBarStack = styled(Stack)`
  flex-direction: row;
  ::-webkit-scrollbar {
    display: none;
  }
`;
